import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useVisaRuntimeData(route: RouteLocationNormalizedLoaded) {
    const countryId = +route.query.countryId
    if (visaRuntimeStore.location.id !== countryId) await visaRuntimeStore.loadLocation(countryId)
}
